export const parseJwt = (token: string) =>
    JSON.parse(
        decodeURIComponent(
            atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
                .split("")
                .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                .join(""),
        ),
    );

export const isTokenExpired = (token: string) =>
    new Date(new Date().toISOString()).getTime() / 1000 > parseJwt(token).exp;
